import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'

export default class Modalfinance extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

               // send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                namepresent : '', //ผู้นำเสนอ
                send_name : '', //ชื่อบทความ
                major_precent : '', //สาขาที่นำเสนอ
                send_uploadeword1 : null,
                send_uploadepdf1 : null,
                send_uploadeword12 : null,
                send_uploadepdf12 : null,
                send_date1 : '', //  วันที่ส่ง
                send_status : '', //สถานะ ชำระเงิน
                stapat : '0',   //สถานะส่ง

                iduser:'',

                
                id_send:'',
                send_id:'',
                date_showslip:'', //วันที่ชำระ
                date_showinvote:'',//วันที่โชว์ในใบเสร็จ
                name_showinvote:'',
                send_money:'', //จำนวนเงิน
                send_song:'', //ประเภทการโอน
                send_fileslip: null,

                }

                this.handleChange1 = this.handleChange1.bind(this);
                this.handleChange2 = this.handleChange2.bind(this);
                this.handleChange3 = this.handleChange3.bind(this);
                this.handleChange4 = this.handleChange4.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.handleChangemajor = this.handleChangemajor.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.handleChangesend_name2 = this.handleChangesend_name2.bind(this);
                
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
}


 componentDidMount() {
       const { id_send } = this.props.id_send
        const { send_id } = this.props.send_id
      // console.log(id_send);
        this.setState({ id_send:this.props.id_send})
        this.setState({ send_id:this.props.send_id})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 
//     }, 0);

// }



 
  //ประเภท
  handleChangemajor(event) {    this.setState({send_song: event.target.value});  }
  //วันที่โอน
  handleChangenamepresent(event) {    this.setState({date_showslip: event.target.value});  }
  //วันที่โชว
  handleChangesend_name(event) {    this.setState({date_showinvote: event.target.value});  }
  handleChangesend_name2(event) {    this.setState({name_showinvote: event.target.value});  }
  //จำนวนเงิน
  handleChangetype(event) {    this.setState({send_money: event.target.value});  }
  //ไฟล์
  handleChange1(event) {    this.setState({send_fileslip: event.target.files[0]});  }


 //ปากเปล่าโปสเตอร์
 // handleChangetype(event) {    this.setState({send_type: event.target.value});  }
  handleChange2(event) {    this.setState({send_uploadepdf1: event.target.files[0]});  }
  handleChange3(event) {    this.setState({send_uploadeword12: event.target.files[0]});  }
  handleChange4(event) {    this.setState({send_uploadepdf12: event.target.files[0]});  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.props.id_send);
      datafrm.append("send_id", this.state.send_id);
      datafrm.append("date_showslip", this.state.date_showslip);
      datafrm.append("date_showinvote", this.state.date_showinvote);
      datafrm.append("name_showinvote", this.state.name_showinvote);
      datafrm.append("send_money", this.state.send_money);
      datafrm.append("send_song", this.state.send_song);
      datafrm.append("send_fileslip", this.state.send_fileslip);
      datafrm.append("send_status", '1');

  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/uploadslip.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data.status = 'success999') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'บันทึกหลักฐานสำเร็จ',
      text: "You won't be able to revert this!",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.date_showslip)
          console.log(this.state.date_showinvote)
          console.log(this.state.send_money)
          console.log(this.state.send_song)
          console.log(this.state.send_fileslip)


        return (
            <>
            <MDBBtn color="unique" onClick={this.toggle} size="sm"><MDBIcon icon="file-invoice-dollar" /> แนบหลักฐานชำระเงิน</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>แนบหลักฐานชำระเงิน</MDBModalHeader>
              <MDBModalBody>
              <div>

                           {/* <p2>ชื่อบทความ : {this.props.send_name}</p2><br/> */}

                            <div className="mb-2 text-left">
                            <label><strong>ประเภทการชำระ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangemajor}>
                                        <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                         <option value="mobile banking" >mobile banking</option>
                                         <option value="ATM ธนาคาร" >ATM ธนาคาร</option>
                                         <option value="เคาน์เตอร์ธนาคารกรุงไทย" >เคาน์เตอร์ธนาคารกรุงไทย</option>
                            </select>
                            </div>
                            
                            {/* <div className="mb-2">
                            <label><strong>ประเภทการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype}>
                                        <option>------กรุณาเลือกประเภทนำเสนอ------</option>
                                         <option value="1" >นำเสนอแบบปากเปล่า</option>
                                         <option value="2" >นำเสนอแบบโปสเตอร์</option>
                            </select>
                            </div> */}

                            <div className="mb-2">
                           <label><strong>วันเวลา ที่โอน เช่น 10/11/68 17.08 น.</strong></label>
                           <input className="form-control" onChange={this.handleChangenamepresent} name="date_showslip"
                                    value={this.state.date_showslip} placeholder="กรุณาระบุวันเวลา ที่โอน" required />
                            </div>
                  

                           <div className="mb-2">
                           <label><strong>จำนวนเงิน</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="send_money"
                                    value={this.state.send_money} placeholder="กรุณาระบุจำนวนเงิน" required />
                            </div>

                            <div className="mb-2">
                           <label><strong>วันที่ต้องการให้แสดงในใบเสร็จ เช่น 10 พ.ย. 2568</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_name} name="date_showinvote"
                                    value={this.state.date_showinvote} placeholder="กรุณาระบุวันที่ต้องการให้แสดงในใบเสร็จ" required />
                            </div>

                            <div className="mb-2">
                           <label><strong>ชื่อ - นามสกุล ที่ต้องการให้แสดงในใบเสร็จ เช่น นายฐิตินนท์ โชติฐิตินนท์กุล หรือ มหาวิทยาลัยราชภัฏกำแพงเพชร</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_name2} name="name_showinvote"
                                    value={this.state.name_showinvote} placeholder="กรุณาระบุชื่อ - นามสกุล ที่ต้องการให้แสดงในใบเสร็จ" required />
                            </div>


                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์หลักฐานการชำระ .jpg, .png</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange1}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="image/*"
                                    />
                            </div>


              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
